import React, { Component } from "react";
import PageHeaderWrapper from '../../../components/PageHeaderWrapper';
import { TableComp } from "sz-react-utils";
import moment from "moment";
import _ from "lodash";
import { Button, Card, Col, Drawer, Input, Row, Select, Tabs, notification, Switch } from "antd";

import Request, { API_URL, LAPI_URL, MEDIA_URL } from "../../../request";
import { connect } from "react-redux";
import styles from './styles.less'
import common from "../../common.less";
import userRights from "../../../components/_utils/userRights"
const showChannelPartner = userRights.getUserAuth('showChannelPartner');
const Option = Select.Option;
const TabPane = Tabs.TabPane;
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};


class AdvancedFilters extends React.Component {
    state = {
        visible: true,
        suggestCountryId: null
    }


    onClose = () => {
        this.props.onClose(this.state);
    }

    componentDidMount() {
        let { state } = this.props;
        this.setState({ ...state });
    }

    onIeltsChange = (event) => {
        this.setState({
            isIeltsScoreAcceptable: event
        });
    }


    loadStates = (obj) => {
        Request.loadStatesByCountry(obj)
            .then((daa) => {
                let temp = [];
                _.each(daa.result, (vv) => {
                    temp.push({
                        display: vv.stateName,
                        id: vv._id,
                    });
                });
                if (obj.type === 'All Course')
                    this.setState({ stateArr: temp });
                else if (obj.type === 'Suggested Course')
                    this.setState({ suggestStateArr: temp });
            })
            .catch((err) => {
            });
    };

    loadCities = (Obj) => {
        if (Obj) {
            return new Promise(async (resolve) => {
                let data = await Request.loadCitiesForCourseFinder(Obj);
                let temp = [];
                _.each(data.result, (vv) => {
                    temp.push({
                        display: vv.cityName,
                        id: vv._id,
                    });
                });
                this.setState({ cityArr: temp });
            });
        }
    };

    onDegreeChange = (event) => {
        this.setState({
            isBachelorDegreeAcceptable: event
        })
    }


    onMoiChange = (event) => {
        this.setState({
            isMoi: event
        })
    }

    onPreferredPartner = (event) => {
        this.setState({
            isPreferredPartner: event
        })
    }
    onAvailabilityLink = (event) => {
        this.setState({
            isAvailabilityLink: event
        })
    }

    onCountryChoose = (countryId) => {
        this.setState(
            {
                universityCountryId: countryId,
                countryId: null,
                stateId: null,
                universityCityId: [],
                universityStateId: [],
            },
            () => {
                this.loadStates({
                    id: countryId,
                    type: "All Course"
                });
                this.setState({ selectCountry: countryId, universityStateId: [] });
                setTimeout(() => {
                    this.loadCities({
                        countryId: countryId,
                        stateId: this.state.selectState,
                    });
                }, 500);

                // this.table.current.reload();
            }
        );
    };

    onCampusChoose = (v) => {
        this.setState({ courseCampusId: v });
    }

    onSuggestedFacultyChoose = (v) => {
        this.setState({ courseFacultyId: v });
    };

    onStateChoose = (v) => {
        this.setState(
            { universityStateId: v, universityCityId: [], stateId: null },
            () => {
                this.setState({ selectState: v });
                setTimeout(() => {
                    this.loadCities({
                        countryId: this.state.selectCountry,
                        stateId: this.state.selectState,
                    });
                }, 500);
            }
        );
    };

    onCityChoose = (v) => {
        this.setState({ universityCityId: v });
    };

    onChangeIntake = (data) => {
        let x = [];
        data.forEach(v => {
            if (v === 'Jan') { x.push('-01-'); }
            else if (v === 'Feb') { x.push('-02-'); }
            else if (v === 'Mar') { x.push('-03-'); }
            else if (v === 'April') { x.push('-04-'); }
            else if (v === 'May') { x.push('-05-'); }
            else if (v === 'June') { x.push('-06-'); }
            else if (v === 'July') { x.push('-07-'); }
            else if (v === 'Aug') { x.push('-08-'); }
            else if (v === 'Sept') { x.push('-09-'); }
            else if (v === 'Oct') { x.push('-10-'); }
            else if (v === 'Nov') { x.push('-11-'); }
            else if (v === 'Dec') { x.push('-12-'); }
        });
        this.setState({ intakes: x });
    };

    render() {
        let { countryArr, cityArr, stateArr, universityCountryId } = this.state;
        return (
            <Drawer
                title={` Advanced Filters `}
                placement={"right"}
                width={450}
                closable={true}
                onClose={this.onClose}
                visible={this.state.visible}
            >
                <Card bordered={true}>
                    <Row>
                        <label>SEARCH BY COUNTRY</label>
                        <Select style={{ padding: '0.5rem 0rem' }}
                            allowClear
                            mode="tags"
                            className={common.width100Pr}
                            showSearch={true}
                            value={this.state.universityCountryId}
                            placeholder="Select Country"
                            optionFilterProp="display"
                            onChange={this.onCountryChoose}
                            filterOption={(input, option) => {
                                return (
                                    option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                );
                            }}
                        >
                            {countryArr && countryArr.map((val, idn) => {
                                return (
                                    <Option key={idn} value={val.id}>
                                        {val.display}
                                    </Option>
                                );
                            })}
                        </Select>
                    </Row>
                    <Row>
                        <label>SEARCH BY STATE</label>
                        <Select style={{ padding: '0.5rem 0rem' }}
                            allowClear
                            mode="tags"
                            showSearch={true}
                            className={common.width100Pr}
                            value={this.state.universityStateId}
                            placeholder="Select State"
                            optionFilterProp="display"
                            onChange={this.onStateChoose}
                            filterOption={(input, option) => {
                                return (
                                    option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                );
                            }}
                        >
                            {stateArr && stateArr.map((val, idn) => {
                                return (
                                    <Option key={idn} value={val.id}>
                                        {val.display}
                                    </Option>
                                );
                            })}
                        </Select>
                    </Row>
                    <Row>
                        <label>SEARCH BY CITY</label>
                        <Select style={{ padding: '0.5rem 0rem' }}
                            mode="multiple"
                            allowClear
                            showSearch={true}
                            className={common.width100Pr}
                            value={this.state.universityCityId}
                            placeholder="Select City"
                            optionFilterProp="display"
                            onChange={this.onCityChoose}
                            filterOption={(input, option) => {
                                return (
                                    option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                );
                            }}
                        >
                            {cityArr && cityArr.map((val, idn) => {
                                return (
                                    <Option key={idn} value={val.id}>
                                        {val.display}
                                    </Option>
                                );
                            })}
                        </Select>
                    </Row>
                    <Row>
                        <label>SEARCH BY CAMPUS</label>
                        <Select
                            style={{ padding: '0.5rem 0rem' }}
                            allowClear
                            showSearch={true}
                            className={common.width100Pr}
                            value={this.state.courseCampusId}
                            placeholder="Select Campus"
                            optionFilterProp="campusName"
                            onChange={this.onCampusChoose}
                            filterOption={(input, option) => {
                                return (
                                    option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                );
                            }}
                        >
                            {this.state.campusArr && this.state.campusArr.map((val, idn) => {
                                return (
                                    <Option key={idn} value={val._id}>
                                        {val.campusName}
                                    </Option>
                                );
                            })}
                        </Select>
                        <Row>
                            <label>SEARCH BY FACULTY</label>
                            <Select
                                style={{ padding: '0.5rem 0rem' }}
                                allowClear
                                showSearch={true}
                                className={common.width100Pr}
                                value={this.state.courseFacultyId}
                                placeholder="Select Faculty"
                                optionFilterProp="display"
                                onChange={this.onSuggestedFacultyChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {this.state.allFaculties &&
                                    this.state.allFaculties.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val._id}>
                                                {val.display}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        </Row>
                        <Row>
                            <label>SEARCH BY STREAM</label>
                            <Select
                                style={{ padding: '0.5rem 0rem' }}
                                allowClear={true}
                                value={this.state.stream}
                                showSearch={true}
                                placeholder="Select Stream"
                                className={common.width100Pr}
                                onChange={(streams) => {
                                    this.setState({ stream: streams });
                                }}
                            >
                                <Option value={"MEDICAL"}>MEDICAL</Option>
                                <Option value={"NON-MEDICAL"}>NON MEDICAL</Option>
                                <Option value={"COMMERCE"}>COMMERCE</Option>
                                <Option value={"ARTS"}>ARTS</Option>
                            </Select>
                        </Row>
                    </Row>
                    <Row>
                        <label>SEARCH BY LEVEL</label>
                        <Select
                            style={{ padding: '0.5rem 0rem' }}
                            allowClear
                            showSearch={true}
                            className={common.width100Pr}
                            placeholder="Select Level"
                            optionFilterProp="display"
                            value={this.state.courseLevelId}
                            onChange={(v) => {
                                this.setState({ courseLevelId: v });
                            }}
                            filterOption={(input, option) => {
                                return (
                                    option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                );
                            }}
                        >
                            {this.state.levelArr &&
                                this.state.levelArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val.id}>
                                            {val.display}
                                        </Option>
                                    );
                                })}
                        </Select>
                    </Row>
                    <Row>
                        <label>SEARCH BY DURATION</label>
                        <Select
                            style={{ padding: '0.5rem 0rem' }}
                            allowClear={true}
                            className={common.width100Pr}
                            value={this.state.courseDuration}
                            onChange={(py) => {
                                let x = py;
                                this.setState({ courseDuration: x });
                            }}>
                            <option value={''}>Choose Option</option>
                            <option value={1}>One year or less</option>
                            <option value={2}>Two years</option>
                            <option value={3}>Three years</option>
                            <option value={4}>Four years or more</option>
                        </Select>
                    </Row>
                    <Row>
                        <label>SEARCH BY FEE(5000 - {this.state.suggestCourseFeeData})</label>
                        <Input
                            style={{ padding: '0.5rem 0rem' }}
                            type="range"
                            min={5000}
                            max={50000}
                            step={5000}
                            value={this.state.courseFeeData}
                            onChange={(py) => {
                                let x = py.target.value;
                                this.setState({ courseFeeData: x });
                            }}
                        />
                    </Row>
                    <Row>
                        <label>SEARCH BY INTAKE</label>
                        <Select style={{ padding: '0.5rem 0rem' }}
                            className={common.width100Pr}
                            showSearch
                            allowClear
                            mode={"tags"}
                            placeholder="Intake"
                            onChange={this.onChangeIntake}
                        >
                            <Option value={'Jan'}>Jan</Option>
                            <Option value={'Feb'}>Feb</Option>
                            <Option value={'Mar'}>Mar</Option>
                            <Option value={'April'}>April</Option>
                            <Option value={'May'}>May</Option>
                            <Option value={'June'}>June</Option>
                            <Option value={'July'}>July</Option>
                            <Option value={'Aug'}>Aug</Option>
                            <Option value={'Sept'}>Sept</Option>
                            <Option value={'Oct'}>Oct</Option>
                            <Option value={'Nov'}>Nov</Option>
                            <Option value={'Dec'}>Dec</Option>

                        </Select>
                    </Row>
                    <Row>
                        <label>SEARCH BY EXAM TYPE</label>
                        <Select style={{ padding: '0.5rem 0rem' }}
                            placeholder={'Choose Exam'}
                            value={this.state.examType}
                            allowClear
                            className={common.width100Pr}
                            onChange={ei => {
                                this.setState({ examType: ei }, () => {
                                    this.table.current.reload();
                                });
                            }}>
                            <Option value={'IELTS'}>IELTS</Option>
                            <Option value={'PTE'}>PTE</Option>
                            <Option value={'TOEFL'}>TOEFL</Option>
                            <Option value={'CAE'}>CAE</Option>
                        </Select>
                    </Row>
                    <Row>
                        <label>Partnership</label>
                        <Select style={{ padding: '0.5rem 0rem' }}
                            placeholder={'Partnership'}
                            value={this.state.partnership}
                            allowClear
                            className={common.width100Pr}
                            onChange={ei => {
                                this.setState({ partnership: ei });
                            }}>
                            {
                                this.state.partnershipData && this.state.partnershipData.map((partnershipType, index) => {
                                    return (<Option key={index} value={partnershipType.id}>{partnershipType.display}</Option>)
                                })
                            }
                        </Select>
                    </Row>
                    <Row>
                        <label>Accept Previous Refusal</label>
                        <Select style={{ padding: '0.5rem 0rem' }}
                            placeholder={'acceptPreviousRefusal'}
                            value={this.state.acceptPreviousRefusal}
                            allowClear
                            className={common.width100Pr}
                            onChange={ei => {
                                this.setState({ acceptPreviousRefusal: ei });
                            }}>
                            <Option value={"Yes"} >Yes</Option>
                            <Option value={"No"} >No</Option>
                        </Select>
                    </Row>
                    <Row style={{ padding: '0.5rem 0rem' }}>
                        <label>IELTS 5.5 (Acceptable in one module)</label>
                        <Switch
                            size="small"
                            style={{ padding: '0.5rem 0rem' }}
                            name="checkboxIeltsScoreAcceptable"
                            onChange={this.onIeltsChange}
                            checked={this.state.isIeltsScoreAcceptable}
                        />
                    </Row>
                    <Row style={{ padding: '0.5rem 0rem' }}>
                        <label>3 Years Bachelor degree acceptance</label>
                        <Switch
                            size="small"
                            style={{ padding: '0.5rem 0rem' }}
                            name="checkboxBachelorDegreeAcceptable"
                            onChange={this.onDegreeChange}
                            checked={this.state.isBachelorDegreeAcceptable}
                        />
                    </Row>
                    <Row style={{ padding: '0.5rem 0rem' }}>
                        <label>MOI</label>
                        <Switch
                            size="small"
                            style={{ padding: '0.5rem 0rem' }}
                            name="moi"
                            onChange={this.onMoiChange}
                            checked={this.state.isMoi}
                        />
                    </Row>
                    <Row style={{ padding: '0.5rem 0rem' }}>
                        <label>Preferred Partner</label>
                        <Switch
                            size="small"
                            name="preferredPartner"
                            onChange={this.onPreferredPartner}
                            checked={this.state.isPreferredPartner}
                        />
                    </Row>
                    <Row style={{ padding: '0.5rem 0rem' }}>
                        <label>University which have availability link</label>
                        <Switch
                            size="small"
                            name="availabilityLink"
                            onChange={this.onAvailabilityLink}
                            checked={this.state.isAvailabilityLink}
                        />
                    </Row>
                    <Row>
                        <Button type="primary" onClick={this.onClose}>Submit</Button>
                    </Row>
                </Card>
            </Drawer >
        )
    }
}



class CollapseViewBox extends Component {

    state = {
        cp: true
    }

    render() {
        const { cp } = this.state

        return <React.Fragment>
            <div className={cp ? styles.textarraycollapse : styles.textcollapsenot}>{this.props.children}</div>
            <button style={{ color: 'red', float: 'right' }} onClick={() => {
                this.setState({
                    cp: !cp
                })
            }}>
                {cp ? <p>View More + </p> : <p>View Less - </p>}
            </button>
        </React.Fragment>
    }
}

class CourseFinder extends Component {
    state = {
        total: 0,
        allCourseCount: 0,
        suggCourseCount: 0,
        campusArr: [],
        uniArr: [],
        countryArr: [],
        levelArr: [],
        stateArr: [],
        courseFeeData: 500000,
        courseNameData: "",
        cityArr: [],
        courseUniversityId: "",
        courseCampusId: "",
        courseLevelId: [],
        visible: true,
        selectCourseIds: [],
        selectCountry: null,
        selectState: null,
        suggestName: null,
        suggestUniId: null,
        suggestCampId: null,
        suggestCountryId: null,
        suggestStateId: null,
        suggestCityId: null,
        suggestCourseFacultyId: "",
        suggestCourseLevelId: "",
        suggestStateArr: [],
        suggestCityArr: [],
        couArr: [],
        courseFacultyId: [],
        allFaculties: [],
        stream: [],
        suggestStream: "",
        courseDuration: "",
        suggestCourseDuration: "",
        suggestCourseFeeData: 50000,
        intakes: [],
        isIeltsScoreAcceptable: false,
        isBachelorDegreeAcceptable: false,
        isMoi: false,
        isPreferredPartner: false,
        isAvailabilityLink: false,
        isSuggestedAvailabilityLink: false,
        incentiveThroughCPApplication: 'Yes',
        partnershipData: [],
        // partnership: 'Direct',
        partnership: null,
        courseUniversityIds: [],
        countryIds: [],
        stateIds: [],
        cityIds: [],
        campusIds: [],
        courseFacultyIds: [],
        activeKey: '1',
        info: {},
        showAdvancedDrawer: false,
        acceptPreviousRefusal: null
    };

    constructor(props) {
        super(props);
        this.loadUni();

        this.loadCountry();
        this.loadLevels();
        this.loadFaculties();
        this.table = React.createRef();
        this.table2 = React.createRef();
        let selectCourseIds = [];
        _.each(this.props.selectCourseIds, (item) => {
            selectCourseIds.push(item.courseId);
        });
        setTimeout(() => {
            this.setState({
                selectCourseIds,
            });
        }, 1000);
    }

    componentWillReceiveProps(nextProps, nextContext) {
    }

    loadInquiry = async () => {
        let { inquiryId } = this.props
        if (inquiryId) {
            let universityCountryId = []
            let { doc } = await Request.getInquiry(inquiryId)
            if (doc && doc.totalPreference && doc.totalPreference.length > 0) {
                _.each(doc.totalPreference, (preference) => {
                    universityCountryId.push(preference.countryId)
                })

                this.setState({ universityCountryId, suggestCountryId: universityCountryId, info: doc })
                // this.table.current.reload()
            }
        }
    }
    async componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search);
        this.loadInquiry();
        if (searchParams.get("courseUniversityId")) {
            setTimeout(() => {
                this.setState(
                    { courseUniversityId: searchParams.get("courseUniversityId") },
                    () => {
                        this.table.current.reload();
                    }
                );
            }, 1000);
        } else {
        }

        if (!this.props.isComponent) {
            this.loadSuggestUni();
        }
    }

    handleTabChange = (key) => {
        this.setState({ activeKey: key, total: key === 0 ? this.state.allCourseCount : this.state.suggCourseCount });
    }

    loadFaculties = async () => {
        let params = {
            sortField: "facultyName",
            sortOrder: "ascend",
            results: 100,
            count: 100,
        };
        Request.loadSimpleFaculties({ ...params })
            .then((resp) => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.facultyName });
                    return temp;
                }, []);

                this.setState({ allFaculties: resp.data });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    loadSuggestUni = async () => {
        let x = await Request.loadSuggestUni({ _id: this.props.inquiryId });
        this.setState({ couArr: x.arr });
    };

    loadUni = async () => {
        let arr = await Request.loadSimpleUniversities();
        this.setState({ uniArr: arr.arr });
        let params = {
            results: 1000,
            count: 1000
        }
        let response = await Request.getAllUniversityPartnership(params)
        let partnershipData = []
        _.each(response.data, (item) => {
            partnershipData.push({ id: item.partnershipName, display: item.partnershipName })
        })
        this.setState({ partnershipData });
    };
    loadUniCampus = async (uniId) => {
        let arr = await Request.loadUniCampus(uniId);
        this.setState({ campusArr: arr.data });
    };

    handleAdvancedSubmit = (data) => {
        this.setState({ ...data }, () => {
            this.table.current.reload();
        });
        // this.setState({
        //     advancedFilterData: data
        // });
    };
    onCountryChoose = (countryId) => {
        this.setState(
            {
                universityCountryId: countryId,
                countryId: null,
                stateId: null,
                universityCityId: [],
                universityStateId: [],
            },
            () => {
                this.loadStates({
                    id: countryId,
                    type: "All Course"
                });
                this.setState({ selectCountry: countryId, universityStateId: [] });
                setTimeout(() => {
                    this.loadCities({
                        countryId: countryId,
                        stateId: this.state.selectState,
                    });
                }, 500);

                this.table.current.reload();
            }
        );
    };

    onSuggCountryChoose = (v) => {
        this.setState(
            {
                suggestCountryId: v,
                suggestStateId: null,
                suggestCityId: null,
            },
            () => {
                this.loadStates({
                    id: v,
                    type: "Suggested Course"
                });
                this.table2.current.reload();

            }
        );
    };

    onChangeIntake = (data) => {
        let x = [];
        data.forEach(v => {
            if (v === 'Jan') {
                x.push('-01-');
            } else if (v === 'Feb') {
                x.push('-02-');
            } else if (v === 'Mar') {
                x.push('-03-');
            } else if (v === 'April') {
                x.push('-04-');
            } else if (v === 'May') {
                x.push('-05-');
            } else if (v === 'June') {
                x.push('-06-');
            } else if (v === 'July') {
                x.push('-07-');
            } else if (v === 'Aug') {
                x.push('-08-');
            } else if (v === 'Sept') {
                x.push('-09-');
            } else if (v === 'Oct') {
                x.push('-10-');
            } else if (v === 'Nov') {
                x.push('-11-');
            } else if (v === 'Dec') {
                x.push('-12-');
            }
        });

        this.setState(
            { intakes: x },
            () =>
                this.table.current.reload()
        )
    }
    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            if (this.state.courseUniversityId && this.state.courseUniversityId !== '') {
                params.courseUniversityId = this.state.courseUniversityId;
            }
            if (this.state.courseCampusId && this.state.courseCampusId !== '') {
                params.courseCampusId = this.state.courseCampusId;
            }

            if (this.state.suggestCampId && this.state.suggestCampId !== '') {
                params.courseCampusId = this.state.suggestCampId;
            }

            if (this.state.universityCountryId && this.state.universityCountryId.length > 0) {
                params.universityCountryId = Array.isArray(this.state.universityCountryId) ? this.state.universityCountryId.join(',') : this.state.universityCountryId;
            } else { delete params.universityCountryId; }

            if (this.state.selectCountry && this.state.selectCountry.length > 0) {
                params.universityCountryId = Array.isArray(this.state.selectCountry) ? this.state.selectCountry.join(',') : this.state.selectCountry;
            }

            if (this.state.universityStateId && this.state.universityStateId.length > 0) {
                params.universityStateId = Array.isArray(this.state.universityStateId) ? this.state.universityStateId.join(',') : this.state.universityStateId;
            } else { delete params.universityStateId; }

            if (this.state.selectState && this.state.selectState.length > 0) {
                params.universityStateId = Array.isArray(this.state.selectState) ? this.state.selectState.join(',') : this.state.selectState;
            }

            if (this.state.universityCityId && this.state.universityCityId.length > 0) {
                params.universityCityId = Array.isArray(this.state.universityCityId) ? this.state.universityCityId.join(',') : this.state.universityCityId;
            } else { delete params.universityCityId; }

            if (this.state.courseLevelId && this.state.courseLevelId.length > 0) {
                params.courseLevelId = Array.isArray(this.state.courseLevelId) ? this.state.courseLevelId.join(',') : this.state.courseLevelId;
            } else { delete params.courseLevelId; }

            if (this.state.courseNameData && this.state.courseNameData !== '') {
                params.courseName = this.state.courseNameData;
            }
            if (this.state.courseFeeData && this.state.courseFeeData !== '' && Number(this.state.courseFeeData) < 500000) {
                params.tutionFee = this.state.courseFeeData;
            } else { delete params.tutionFee; }
            if (this.state.courseFacultyId && this.state.courseFacultyId.length > 0) {
                params.courseFacultyId = Array.isArray(this.state.courseFacultyId) ? this.state.courseFacultyId.join(',') : this.state.courseFacultyId;
            } else { delete params.courseFacultyId; }

            if (this.state && this.state.stream && this.state.stream.length > 0) {
                params.stream = Array.isArray(this.state.stream) ? this.state.stream.join(',') : this.state.stream;
            } else { delete params.stream; }

            if (this.state.courseDuration && this.state.courseDuration !== '') {
                params.courseDuration = this.state.courseDuration;
            }
            if (this.state.intakes && this.state.intakes.length > 0) {
                params.intakes = Array.isArray(this.state.intakes) ? this.state.intakes.join(',') : this.state.intakes;
            } else { delete params.intakes; }
            if (this.state.examType && this.state.examType !== '') {
                params.examType = this.state.examType;
            }
            if (this.state.partnership && this.state.partnership !== '') {
                params.universityPartnership = this.state.partnership;
            }
            if (this.state.acceptPreviousRefusal) {
                params.acceptPreviousRefusal = this.state.acceptPreviousRefusal;
            }
            if (this.state.isIeltsScoreAcceptable && this.state.isIeltsScoreAcceptable !== '') {
                params.isIeltsScoreAcceptable = true;
            }
            if (this.state.isBachelorDegreeAcceptable && this.state.isBachelorDegreeAcceptable !== '') {
                params.isBachelorDegreeAcceptable = true;
            }
            if (this.state.isMoi && this.state.isMoi !== '') {
                params.isMoi = true;
            }
            if (this.state.isPreferredPartner && this.state.isPreferredPartner !== '') {
                params.isPreferredPartner = true;
            }
            if (this.state.isAvailabilityLink && this.state.isAvailabilityLink !== '') {
                params.isAvailabilityLink = true;
            }
            if (params.sortField && params.sortField === "courseName") {
                params.sortField = "course.courseName";
            }

            let data = await Request.getAllCourseForCounselling(params);
            this.setState({ allCourseCount: data.total, total: data.total, incentiveThroughCPApplication: data.incentiveThroughCPApplication });
            this.getsuggestedFilterData(params);
            resolve(data);
        });
    };

    showAdvanceFilter = () => {
        this.setState((prevState) => ({
            ...prevState,
            showAdvancedDrawer: true
        }));
    };


    closeAdvancedFilter = (data = {}) => {
        console.log(data);
        this.setState(
            (prevState) => ({
                ...prevState,
                ...data,
                showAdvancedDrawer: false
            }),
            () => {
                this.table.current.reload();
            }
        );
    };


    resetForm = () => {
        this.setState({
            suggestName: '',
            suggestUniId: '',
            suggestCampId: '',
            suggestCountryId: '',
            suggestStateId: '',
            suggestCityId: '',
            suggestCourseFacultyId: '',
            suggestStream: '',
            suggestCourseLevelId: '',
            suggestCourseDuration: '',
            suggestCourseFeeData: 500000,

            courseUniversityId: '',
            courseCampusId: '',
            universityCountryId: '',
            universityStateId: '',
            universityCityId: '',
            courseLevelId: '',
            courseNameData: '',
            courseFeeData: '50000',
            courseFacultyId: '',
            stream: [],
            intakes: [],
            examType: '',
            partnership: '',
            isIeltsScoreAcceptable: '',
            isBachelorDegreeAcceptable: '',
            isMoi: '',
            isPreferredPartner: '',
            isAvailabilityLink: '',
            isSuggestedAvailabilityLink: false,
            selectCountry: null,
            selectState: null,
            showAdvancedDrawer: false,
        }, () => {
            if (this.state.activeKey == 1) {
                this.table.current.reload();
            } else {
                this.table2.current.reload();
            }
        })
    }
    loadSuggestedCourse = (params) => {
        return new Promise(async (resolve) => {
            params = params || {};

            let {
                suggestName,
                suggestUniId,
                suggestCampId,
                suggestCountryId,
                suggestStateId,
                suggestCityId,
                suggestCourseFacultyId,
                suggestStream,
                suggestCourseLevelId,
                suggestCourseDuration,
                suggestCourseFeeData,
            } = this.state;

            params.inquiryId = this.props.inquiryId;
            let { doc } = await Request.getInquiry(this.props.inquiryId)
            if (suggestName) {
                params.courseName = suggestName;
            } else { delete params.courseName; }

            if (suggestUniId) {
                params.courseUniversityId = suggestUniId;
            } else { delete params.courseUniversityId; }

            if (suggestCampId) {
                params.courseCampusId = suggestCampId;
            } else { delete params.courseCampusId; }

            if (suggestCountryId && suggestCountryId.length > 0) {
                params.universityCountryId = Array.isArray(suggestCountryId) ? suggestCountryId.join(',') : suggestCountryId;
            } else { delete params.universityCountryId; }

            if (suggestStateId) {
                params.universityStateId = suggestStateId;
            } else { delete params.universityStateId; }

            if (suggestCityId) {
                params.universityCityId = suggestCityId;
            } else { delete params.universityCityId; }

            if (suggestCourseFacultyId) {
                params.courseFacultyId = suggestCourseFacultyId;
            } else { delete params.courseFacultyId; }

            if (suggestStream) {
                params.stream = suggestStream;
            } else { delete params.stream; }

            if (suggestCourseLevelId) {
                params.courseLevel = suggestCourseLevelId;
            } else { delete params.courseLevel; }

            if (suggestCourseDuration) {
                params.courseDuration = suggestCourseDuration;
            } else { delete params.courseDuration; }

            if (suggestCourseFeeData) {
                params.tutionFee = suggestCourseFeeData;
            } else { delete params.tutionFee; }

            if (this.state.isSuggestedAvailabilityLink && this.state.isSuggestedAvailabilityLink !== '') {
                params.isSuggestedAvailabilityLink = true;
            } else { delete params.isSuggestedAvailabilityLink; }
            if (doc && doc.profile && doc.profile.newQualification && doc.profile.newQualification.length && doc.totalPreference.length) {
                let data = await Request.getAllSuggestedCourse(params);
                this.setState({ suggCourseCount: data.total, total: data.total, incentiveThroughCPApplication: data.incentiveThroughCPApplication });
                resolve(data);
            } else {
                resolve(0)
            }

            this.getsuggestedFilterData(params);
        });
    };
    getsuggestedFilterData = async (params) => {
        let response = await Request.loadSuggestFilterData(params);
        if (response) {
            let { courseUniversityIds,
                countryIds,
                stateIds,
                cityIds,
                campusIds,
                courseFacultyIds } = response;
            this.setState({
                courseUniversityIds,
                countryIds,
                stateIds,
                cityIds,
                campusIds,
                courseFacultyIds
            })
        }
    }
    onUniChoose = (v) => {
        this.setState({ courseUniversityId: v }, () => {
            this.loadUniCampus(v);
            this.table.current.reload();
        });
    };
    onCampChoose = (v) => {
        this.setState({ courseCampusId: v }, () => {
            this.table.current.reload();
        });
    }
    loadLevels = async () => {
        let params = { sortField: "levelName", sortOrder: "ascend", results: 100 };
        Request.loadSimpleLevels({ ...params })
            .then((resp) => {
                if (resp) {
                    let temp = [];
                    _.each(resp.data, (vv) => {
                        temp.push({
                            display: vv.levelName,
                            id: vv._id.toString(),
                        });
                    });
                    this.setState({ levelArr: temp });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    onClose = () => {
        this.setState({
            visible: false,
        });
        this.props.onClose();
    };
    callback = (value) => {
        // let incentiveThroughCPApplication = this.state.incentiveThroughCPApplication;
        // if(incentiveThroughCPApplication == 'No' && value.universityPartnership == 'Channel Partner') {
        //     notification.error({
        //         message: 'NOTE! ',
        //         description: 'If you choose Channel Partner University then your Incentive is Zero.',
        //         duration: 5
        //     })
        // }
        value.key = value._id;
        value.courseId = value._id;

        let pathWayName = _.find(value.pathways, (item) => {
            return value.pathwayId === item._id;
        });
        if (pathWayName) {
            value.pathwayName = pathWayName.pathCourse;
        }
        let cloneSelectCourseIds = _.clone(this.state.selectCourseIds);
        if (!cloneSelectCourseIds.includes(value.courseId)) {
            cloneSelectCourseIds.push(value.courseId);
            setTimeout(() => {
                this.setState({ selectCourseIds: cloneSelectCourseIds });
            }, 500);
        }
        if (value.mainCampus && value.mainCampus.length > 0) {
            value['campusId'] = null;
            value['campusName'] = null;
        }
        if (value.channelPartners && value.channelPartners.length > 0) {
            let channelPartners = value.channelPartners;
            value['channelPartnerId'] = channelPartners[0]._id;
            value['channelPartnerName'] = channelPartners[0].channelPartnerName;
        }
        // if (value.channelPartners && value.channelPartners.length > 0) {
        //     value['channelPartnerId'] = null;
        //     value['channelPartnerName'] = null;
        // }
        this.props.callback(value);
    };

    removeCourse = (value) => {
        let cloneSelectCourseIds = _.clone(this.state.selectCourseIds);
        cloneSelectCourseIds = _.reject(cloneSelectCourseIds, (item) => {
            return item === value.courseId;
        });
        setTimeout(() => {
            this.setState({ selectCourseIds: cloneSelectCourseIds });
        }, 500);
        this.props.removeCourse(value);
    };

    loadCountry() {
        let params = {
            results: 100,
            sortField: "countryName",
            sortOrder: "ascend",
            businessId: activeUser && activeUser.businessId
        };
        Request.getCountriesWithoutAuth(params)
            .then((resp) => {
                if (resp) {
                    let temp = [];
                    _.each(resp.data, (vv) => {
                        temp.push({
                            display: vv.countryName,
                            id: vv._id,
                        });
                    });
                    this.setState({ countryArr: temp });
                }
            })
            .catch((err) => {
            });
    }

    loadStates = (obj) => {
        Request.loadStatesByCountry(obj)
            .then((daa) => {
                let temp = [];
                _.each(daa.result, (vv) => {
                    temp.push({
                        display: vv.stateName,
                        id: vv._id,
                    });
                });
                if (obj.type === 'All Course')
                    this.setState({ stateArr: temp });
                else if (obj.type === 'Suggested Course')
                    this.setState({ suggestStateArr: temp });
            })
            .catch((err) => {
            });
    };

    onStateChoose = (v) => {
        this.setState(
            { universityStateId: v, universityCityId: [], stateId: null },
            () => {
                this.setState({ selectState: v });
                setTimeout(() => {
                    this.loadCities({
                        countryId: this.state.selectCountry,
                        stateId: this.state.selectState,
                    });
                }, 500);
                this.table.current.reload();
            }
        );
    };

    onSuggestStateChoose = (v) => {
        this.setState(
            { suggestStateId: v, suggestCityId: null, stateId: null },
            () => {
                setTimeout(() => {
                    this.loadSuggestCities({
                        countryId: this.state.suggestCountryId,
                        stateId: v,
                    });
                }, 500);
                this.table2.current.reload();
            }
        );
    };

    onCityChoose = (v) => {
        this.setState({ universityCityId: v }, () => {
            this.table.current.reload();
        });
    };

    onFacultyChoose = (v) => {
        this.setState({ courseFacultyId: v }, () => {
            this.table.current.reload();
        });
    };

    onSuggestedFacultyChoose = (v) => {
        this.setState({ suggestCourseFacultyId: v }, () => {
            this.table2.current.reload();
        });
    };


    onSuggestCityChoose = (v) => {
        this.setState({ suggestCityId: v }, () => {
            this.table2.current.reload();
        });
    };

    loadCities = (Obj) => {
        if (Obj) {
            return new Promise(async (resolve) => {
                let data = await Request.loadCitiesForCourseFinder(Obj);
                let temp = [];
                _.each(data.result, (vv) => {
                    temp.push({
                        display: vv.cityName,
                        id: vv._id,
                    });
                });
                this.setState({ cityArr: temp });
            });
        }
    };
    loadSuggestCities = (Obj) => {
        if (Obj) {
            return new Promise(async (resolve) => {
                let data = await Request.loadCitiesForCourseFinder(Obj);
                let temp = [];
                _.each(data.result, (vv) => {
                    temp.push({
                        display: vv.cityName,
                        id: vv._id,
                    });
                });
                this.setState({ suggestCityArr: temp });
            });
        }
    };

    onIeltsChange = (event) => {
        this.setState({
            isIeltsScoreAcceptable: event.target.checked
        }, () => this.table.current.reload())
    }

    onDegreeChange = (event) => {
        this.setState({
            isBachelorDegreeAcceptable: event.target.checked
        }, () => this.table.current.reload())
    }

    onMoiChange = (event) => {
        this.setState({
            isMoi: event.target.checked
        }, () => this.table.current.reload())
    }

    onPreferredPartner = (event) => {
        this.setState({
            isPreferredPartner: event.target.checked
        }, () => this.table.current.reload())
    }
    onAvailabilityLink = (event) => {
        this.setState({
            isAvailabilityLink: event.target.checked
        }, () => this.table.current.reload())
    }
    onSuggestedAvailabilityLink = (event) => {
        this.setState({
            isSuggestedAvailabilityLink: event.target.checked
        }, () => this.table2.current.reload())
    }
    checkIeltsRequirement = (record) => {
        let { inquiryProfile } = this.props;
        let ifBandExists = [];
        if (record && record.ieltsRequirements && record.ieltsRequirements.length > 1) {
            record.ieltsRequirements && _.map(record.ieltsRequirements, (item, index) => {
                if ((item.Overall > 0 || item.Reading > 0 || item.Writing > 0 || item.Listening > 0 || item.Speaking > 0) && (!inquiryProfile || inquiryProfile.listening === 0 || inquiryProfile.reading === 0 || inquiryProfile.speaking === 0 || inquiryProfile.writing === 0)) {
                    ifBandExists.push(item.ExamType);
                }
            })
        }
        return ifBandExists.join('/');
    }
    render() {
        let { isComponent, inquiryTotalPreference } = this.props;
        let { showAdvancedDrawer } = this.state;
        let suggestCountryId = this.state.suggestCountryId;
        let incentiveThroughCPApplication = this.state.incentiveThroughCPApplication;
        if (inquiryTotalPreference && inquiryTotalPreference !== undefined) {
            let defCountries = inquiryTotalPreference.filter(tp => tp.countryId !== '').map(el => el.countryId);
            suggestCountryId = suggestCountryId ? suggestCountryId : (defCountries[0] !== undefined ? defCountries[0] : '');
        }

        let columns = [
            {
                title: (

                    !this.props.isComponent ?
                        (<Button type={"primary"} onClick={this.onClose}>
                            Done
                        </Button>)
                        : <h3 style={{ display: 'inline-block', marginLeft: '1rem' }}></h3>

                ),
                width: 70,
                left: true,
                key: "",
                dataIndex: "",
                isVisible: isComponent,
                render: (item, record) => {
                    return (
                        <>
                            {!this.props.isComponent ?
                                <div>
                                    {record.status === "Active" ? (
                                        <div>
                                            {!this.state.selectCourseIds.includes(record._id) ? (
                                                <Button
                                                    className={common.btnInfo}
                                                    size={"small"}
                                                    onClick={() => {
                                                        this.callback(record);
                                                    }}
                                                >
                                                    Select
                                                </Button>
                                            ) : (
                                                <Button
                                                    type={"default"}
                                                    size={"small"}
                                                    onClick={() => {
                                                        this.removeCourse(record);
                                                    }}
                                                >
                                                    Un-Select
                                                </Button>
                                            )}
                                            <br />
                                        </div>
                                    ) : (
                                        <div>Closed</div>
                                    )}
                                </div>
                                : null}
                        </>
                    );
                },
            },
            {
                title: "Course",
                key: "courseName",
                dataIndex: "courseName",
                width: 210,
                render: (item, record) => {
                    return (
                        <div>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={MEDIA_URL + `courseFactSheet/${record.courseId}`}
                            >
                                {item}
                            </a>
                            <br />
                            {this.checkIeltsRequirement(record) ? <small style={{ color: 'red' }}>{this.checkIeltsRequirement(record)} Required for this course.</small> : ''}
                        </div>
                    );
                },
            },
            {
                title: "University",
                width: 150,
                key: "universityInstitutionName",
                dataIndex: "universityInstitutionName",
                render: (val, row) => {
                    return (
                        <div>

                            <div>{row.universityInstitutionName}</div>
                            <small>({row.universityCountryId})</small>
                            <div style={{ color: 'red' }}>
                                {row && row.mainCampus && row.mainCampus.length > 0 ? row.mainCampus.map((val, inde) => {
                                    return <span key={inde}>{val.campusName}, </span>
                                }) : null
                                }
                            </div>
                            {
                                row.availabilityLink ?
                                    <small><a style={{ color: '#d47a0a', fontWeight: '700' }} href={row.availabilityLink} target="_blank" rel="noopener noreferrer">Seats Availability Link</a><br /></small>
                                    : null
                            }

                            {
                                row.pgwpEnabledProgramsLink ?
                                    <small><a style={{ color: '#d47a0a', fontWeight: '700' }} href={row.pgwpEnabledProgramsLink} target="_blank" rel="noopener noreferrer">PGWP eligible programs Link</a></small>
                                    : null
                            }
                        </div>

                    );
                },
            },
            {
                title: "University Type",
                width: 150,
                key: "universityPartnership",
                dataIndex: "universityPartnership",
                isVisible: showChannelPartner,
                render: (val, row) => {
                    return (
                        <div>{val}</div>
                    )
                }
            },
            {
                title: "Application Fee",
                width: 80,
                key: "contactApplicationFee",
                dataIndex: "contactApplicationFee",
                render: (val, record) => {
                    let applicationFee = record.levelName === "Bachelor Degree" || record.levelName === "Associate Degree" || record.levelName === "Diploma/Advanced Diploma" || record.levelName === "Certificate" ? record.contactApplicationFeeUG && record.contactApplicationFeeUG != "0" ? record.currencyName + " " + record.contactApplicationFeeUG : record.contactApplicationFee !== "0" ? record.currencyName + " " + record.contactApplicationFee : "NIL" : record.contactApplicationFeePG
                    return (
                        // <div>{record.levelName === "Bachelor Degree" || record.levelName === "Associate Degree" || record.levelName === "Diploma/Advanced Diploma" || record.levelName === "Certificate" ? record.contactApplicationFee && record.contactApplicationFee != "0" ?}</div>
                        // <div>{record.contactApplicationFee !== "0" ? record.currencyName + " " + record.contactApplicationFee : "NIL"}</div>
                        <div>{applicationFee}</div>
                    );
                },
            },
            {
                title: 'Intakes',
                width: 150,
                key: 'intakes',
                render: (val, record) => {
                    return (
                        <div>
                            {record && record.intakes && record.intakes.length > 0 ? record.intakes.map((val, inde) => {
                                return <span key={inde}>{moment(val).format('MMM')}{`, ${'\n'}`}</span>
                            }) : null}
                        </div>
                    )
                }
            },
            {
                title: "Annual Fees/Duration/Scholarship",
                width: 120,
                key: "tutionFee",
                dataIndex: "tutionFee",

                render: (val, record) => {
                    return (
                        <div>
                            <div>{record.tutionFee !== "0" ? record.currencyName + " " + record.tutionFee : "NIL"}/</div>
                            <div>{record.courseDuration}/</div>
                            <div>{record.scholarship !== null && record.scholarship !== "0" ? record.currencyName + " " + record.scholarship : "NIL"}</div>
                        </div>
                    );
                },
            },
            {
                title: "City/State/Country",
                key: "universityCityId",
                dataIndex: "universityCityId",
                width: 180,
                render: (val, record) => {
                    return (
                        <div>
                            <span>{record.universityCityId}</span>/
                            <span>{record.universityStateId}</span>/
                            <span>{record.universityCountryId}</span>
                        </div>
                    );
                },
            },

            {
                title: "Offer TAT/ Accept Previous Refusal",
                width: 80,
                key: "enrollmentAdmissionOffer",
                dataIndex: "enrollmentAdmissionOffer",
                render: (text, record) => (
                    <div>{text}{record.acceptPreviousRefusal ? `/${record.acceptPreviousRefusal}` : ""}</div>
                )
            },
            {
                title: "Entry Requirements",
                width: 200,
                render: (val, record) => {
                    if (record && record.ieltsRequirements && record.ieltsRequirements.length > 1) {
                        return <CollapseViewBox>
                            <>
                                {record.ieltsRequirements && _.map(record.ieltsRequirements, (item, index) => {
                                    return (
                                        <div key={index} className={styles.alternateColors}>
                                            <div>
                                                <small>ExamType: {item.ExamType}</small>
                                                {`, ${'\n'}`}
                                                <small>Overall: {item.Overall}</small>
                                                {`, ${'\n'}`}
                                                <small>Reading: {item.Reading}</small>
                                                {`, ${'\n'}`}
                                                <small>Writing: {item.Writing}</small>
                                                {`, ${'\n'}`}
                                                <small>Listening: {item.Listening}</small>
                                                {`, ${'\n'}`}
                                                <small>Speaking: {item.Speaking}</small>
                                            </div><br />
                                        </div>

                                    )
                                })}

                                <small>{(record.additionalRequirements && record.additionalRequirements !== "") ? 'Add. Requirements:' + record.additionalRequirements : ''}</small>
                            </>
                        </CollapseViewBox>
                    } else {
                        return (
                            <>
                                <div>{record && record.ieltsRequirements && record.ieltsRequirements.length > 0 &&
                                    record.ieltsRequirements.map((item, c) => {
                                        return (
                                            <div key={c} className={styles.alternateColors}>
                                                <div>
                                                    <small>ExamType: {item.ExamType}</small>
                                                    {`, ${'\n'}`}
                                                    <small>Overall: {item.Overall}</small>
                                                    {`, ${'\n'}`}
                                                    <small>Reading: {item.Reading}</small>
                                                    {`, ${'\n'}`}
                                                    <small>Writing: {item.Writing}</small>
                                                    {`, ${'\n'}`}
                                                    <small>Listening: {item.Listening}</small>
                                                    {`, ${'\n'}`}
                                                    <small>Speaking: {item.Speaking}</small>
                                                </div><br />
                                            </div>
                                        )
                                    })}
                                </div>

                                <small>{(record.additionalRequirements && record.additionalRequirements !== "") ? 'Add. Requirements:' + record.additionalRequirements : ''}</small>
                            </>
                        )
                    }
                }
            },
            {
                title: 'Qualification',
                width: 200,
                render: (val, record) => {
                    if (record && record.qualification && record.qualification.length > 1) {
                        return <CollapseViewBox>
                            {record.qualification && _.map(record.qualification, (item, index) => {
                                return (
                                    <div key={index} className={styles.alternateColors}>
                                        <div>
                                            <small>{(item.qualification && item.qualification !== "") ? 'Qualification:' + item.qualification + ',' : ''}</small>
                                            {`${'\n'}`}
                                            <small>{(item.percentage && item.percentage !== "") ? 'Percentage:' + item.percentage + ',' : ''}</small>
                                            {`${'\n'}`}
                                            <small>{(item.maths && item.maths !== "") ? 'Maths:' + item.maths + ',' : ''}</small>
                                            {`${'\n'}`}
                                            <small>{(item.english && item.english !== "") ? 'English:' + item.english + ',' : ''}</small>
                                            {`${'\n'}`}
                                            <small>{(item.backlogs && item.backlogs !== "") ? 'Backlogs:' + item.backlogs + ',' : ''}</small>
                                            {`${'\n'}`}
                                            <small>{(item.degreeType && item.degreeType !== "") ? 'Degree Type:' + item.degreeType + ',' : ''}</small>
                                            {`${'\n'}`}
                                            <small>{(item.major && item.major !== "") ? 'Major:' + item.major + ',' : ''}</small>
                                            {`${'\n'}`}
                                            <small>{(item.passingYear && item.passingYear !== "") ? 'Passing Year:' + item.passingYear + ',' : ''}</small>
                                            {`${'\n'}`}
                                            <small>
                                                Stream: {Array.isArray(item && item.stream)
                                                    ? item.stream.join()
                                                    : (item && item.stream) || "N/A"}
                                            </small>

                                        </div>
                                    </div>

                                )
                            })}

                        </CollapseViewBox>

                    } else {
                        return (
                            <div>
                                {record && record.qualification && record.qualification.length > 0
                                    ? record.qualification.map((item, c) => {
                                        return (
                                            <div key={c} className={styles.alternateColors}>
                                                <div>
                                                    <small>{(item.qualification && item.qualification !== "") ? 'Qualification:' + item.qualification + ',' : ''}</small>
                                                    {`${'\n'}`}
                                                    <small>{(item.percentage && item.percentage !== "") ? 'Percentage:' + item.percentage + ',' : ''}</small>
                                                    {`${'\n'}`}
                                                    <small>{(item.maths && item.maths !== "") ? 'Maths:' + item.maths : ''}</small>
                                                    {`${'\n'}`}
                                                    <small>{(item.english && item.english !== "") ? 'English:' + item.english + ',' : ''}</small>
                                                    {`${'\n'}`}
                                                    <small>{(item.backlogs && item.backlogs !== "") ? 'Backlogs:' + item.backlogs + ',' : ''}</small>
                                                    {`${'\n'}`}
                                                    <small>{(item.degreeType && item.degreeType !== "") ? 'Degree Type:' + item.degreeType + ',' : ''}</small>
                                                    {`${'\n'}`}
                                                    <small>{(item.major && item.major !== "") ? 'Major:' + item.major + ',' : ''}</small>
                                                    {`${'\n'}`}
                                                    <small>{(item.passingYear && item.passingYear !== "") ? 'Passing Year:' + item.passingYear + ',' : ''}</small>
                                                    {`${'\n'}`}
                                                    <small>Stream :{item && item.stream}</small>
                                                </div>
                                            </div>
                                        )
                                    })
                                    : null}
                            </div>
                        )
                    }
                }

            },
        ];
        columns = columns.filter((col) => { return col.isVisible != false; });

        let {
            countryArr,
            stateArr,
            cityArr,
            uniArr,
            campusArr,
            allFaculties,
            courseUniversityIds,
            countryIds,
            stateIds,
            cityIds,
            campusIds,
            courseFacultyIds
        } = this.state;
        if (countryIds && countryIds.length > 0) {
            countryArr = countryArr.filter((col) => { return countryIds.includes(col.id) != false; });
        }
        if (stateIds && stateIds.length > 0) {
            stateArr = stateArr.filter((col) => { return stateIds.includes(col.id) != false; });
        }
        if (cityIds && cityIds.length > 0) {
            cityArr = cityArr.filter((col) => { return cityIds.includes(col.id) != false; });
        }
        if (courseUniversityIds && courseUniversityIds.length > 0) {
            uniArr = uniArr.filter((col) => { return courseUniversityIds.includes(col._id) != false; });
        }
        if (campusIds && campusIds.length > 0 && campusArr && campusArr.length) {
            campusArr = campusArr.filter((col) => { return campusIds.includes(col._id) != false; });
        }
        if (courseFacultyIds && courseFacultyIds.length > 0) {
            allFaculties = allFaculties.filter((col) => { return courseFacultyIds.includes(col._id) != false; });
        }

        const childUI = <Card bordered={true} style={{ marginBottom: 10 }}>
            <Tabs
                defaultActiveKey={this.props.isComponent ? "0" : "1"}
                type="card"
                tabBarExtraContent={
                    <>
                        <Button
                            type="success"
                            onClick={this.resetForm}
                            style={{ marginRight: '10px' }}
                        >
                            Reset
                        </Button>

                        <Button
                            type="success"
                            onClick={this.showAdvanceFilter}
                            style={{ marginRight: '10px' }}
                        >
                            Advance Filters
                        </Button>

                        {
                            !this.props.isComponent ? (
                                <Button
                                    type="primary"
                                    onClick={this.onClose}
                                    style={{ marginRight: '10px' }}
                                >
                                    Done
                                </Button>
                            ) : (
                                <h3 style={{ display: 'inline-block', marginLeft: '1rem' }}>
                                    Course List : {this.state.total}
                                </h3>
                            )
                        }
                    </>

                }
                onChange={this.handleTabChange}
            >
                {!this.props.isComponent && (
                    <TabPane tab={"SUGGESTED COURSE"} key={!this.props.isComponent ? "1" : "0"}>
                        <Row>
                            <Col span={6}>
                                <label>SEARCH BY COURSE</label>
                                <Input
                                    allowClear={true}
                                    className={common.width100Pr}
                                    onChange={(py) => {
                                        let x = py.target.value;
                                        this.setState({ suggestName: x }, () => {
                                            this.table2.current.reload();
                                        });
                                    }}
                                />
                            </Col>
                            <Col span={6}>
                                <label>SEARCH BY COUNTRY</label>

                                <Select
                                    allowClear
                                    showSearch={true}
                                    className={common.width100Pr}
                                    value={suggestCountryId}
                                    placeholder="Select Country"
                                    optionFilterProp="display"
                                    onChange={this.onSuggCountryChoose}
                                    filterOption={(input, option) => {
                                        return (
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        );
                                    }}
                                >
                                    {this.state.couArr &&
                                        this.state.couArr.map((val, idn) => {
                                            return (
                                                <Option key={idn} value={val.countryId}>
                                                    {val.country}
                                                </Option>
                                            );
                                        })}
                                </Select>
                            </Col>
                            <Col span={6}>
                                <label>SEARCH BY STATE</label>
                                <Select
                                    allowClear
                                    showSearch={true}
                                    className={common.width100Pr}
                                    value={this.state.suggestStateId}
                                    placeholder="Select State"
                                    optionFilterProp="display"
                                    onChange={this.onSuggestStateChoose}
                                    filterOption={(input, option) => {
                                        return (
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        );
                                    }}
                                >
                                    {this.state.suggestStateArr.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val.id}>
                                                {val.display}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </Col>
                            <Col span={6}>
                                <label>SEARCH BY CITY</label>
                                <Select
                                    allowClear
                                    showSearch={true}
                                    className={common.width100Pr}
                                    value={this.state.suggestCityId}
                                    placeholder="Select City"
                                    optionFilterProp="display"
                                    onChange={this.onSuggestCityChoose}
                                    filterOption={(input, option) => {
                                        return (
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        );
                                    }}
                                >
                                    {this.state.suggestCityArr.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val.id}>
                                                {val.display}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 10 }}>
                            <Col span={6}>
                                <label>SEARCH BY UNIVERSITY</label>
                                <Select
                                    allowClear
                                    showSearch={true}
                                    className={common.width100Pr}
                                    value={this.state.suggestUniId}
                                    placeholder="Select University"
                                    optionFilterProp="universityInstitutionName"
                                    onChange={(v) => {
                                        this.setState({ suggestUniId: v }, () => {
                                            this.loadUniCampus(v);
                                            this.table2.current.reload();
                                        });
                                    }}
                                    filterOption={(input, option) => {
                                        return (
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        );
                                    }}
                                >
                                    {this.state.uniArr && this.state.uniArr.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val._id}>
                                                {val.universityInstitutionName}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </Col>
                            <Col span={6}>
                                <label>SEARCH BY CAMPUS</label>
                                <Select
                                    allowClear
                                    showSearch={true}
                                    className={common.width100Pr}
                                    value={this.state.suggestCampId}
                                    placeholder="Select Campus"
                                    optionFilterProp="campusName"
                                    onChange={(v) => {
                                        this.setState({ suggestCampId: v }, () => {
                                            this.table2.current.reload();
                                        });
                                    }}
                                    filterOption={(input, option) => {
                                        return (
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        );
                                    }}
                                >
                                    {this.state.campusArr && this.state.campusArr.map((val, idn) => {
                                        let value = val._id.toString()
                                        return (
                                            <Option key={idn} value={value}>
                                                {val.campusName}
                                            </Option>
                                        );
                                    })}
                                </Select>
                            </Col>
                            <Col span={6}>
                                <label>SEARCH BY FACULTY</label>
                                <Select
                                    allowClear
                                    showSearch={true}
                                    className={common.width100Pr}
                                    value={this.state.suggestCourseFacultyId}
                                    placeholder="Select Faculty"
                                    optionFilterProp="display"
                                    onChange={this.onSuggestedFacultyChoose}
                                    filterOption={(input, option) => {
                                        return (
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        );
                                    }}
                                >
                                    {this.state.allFaculties &&
                                        this.state.allFaculties.map((val, idn) => {
                                            return (
                                                <Option key={idn} value={val._id}>
                                                    {val.display}
                                                </Option>
                                            );
                                        })}
                                </Select>
                            </Col>
                            <Col span={6}>
                                <label>SEARCH BY STREAM</label>
                                <Select
                                    allowClear={true}
                                    value={this.state.suggestStream}
                                    showSearch={true}
                                    placeholder="Select Stream"
                                    className={common.width100Pr}
                                    onChange={(streams) => {
                                        this.setState({ suggestStream: streams }, () => {
                                            this.table2.current.reload();
                                        });
                                    }}
                                >
                                    <Option value={"MEDICAL"}>MEDICAL</Option>
                                    <Option value={"NON-MEDICAL"}>NON MEDICAL</Option>
                                    <Option value={"COMMERCE"}>COMMERCE</Option>
                                    <Option value={"ARTS"}>ARTS</Option>
                                </Select>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 10 }}>
                            <Col span={6}>
                                <label>SEARCH BY LEVEL</label>
                                <Select
                                    allowClear
                                    showSearch={true}
                                    className={common.width100Pr}
                                    placeholder="Select Level"
                                    optionFilterProp="display"
                                    onChange={(v) => {
                                        this.setState({ suggestCourseLevelId: v }, () => {
                                            this.table2.current.reload();
                                        });
                                    }}
                                    filterOption={(input, option) => {
                                        return (
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        );
                                    }}
                                >
                                    {this.state &&
                                        this.state.levelArr.map((val, idn) => {
                                            return (
                                                <Option key={idn} value={val.id}>
                                                    {val.display}
                                                </Option>
                                            );
                                        })}
                                </Select>
                            </Col>
                            <Col span={6}>
                                <label>SEARCH BY DURATION</label>
                                <Select
                                    allowClear={true}
                                    className={common.width100Pr}
                                    onChange={(py) => {
                                        let x = py;
                                        this.setState({ suggestCourseDuration: x }, () => {
                                            this.table.current.reload();
                                        });
                                    }}>
                                    <option value={''}>Choose Option</option>
                                    <option value={1}>One year or less</option>
                                    <option value={2}>Two years</option>
                                    <option value={3}>Three years</option>
                                    <option value={4}>Four years or more</option>
                                </Select>
                            </Col>
                            <Col span={12}>
                                <label>SEARCH BY FEE(5000 - {this.state.suggestCourseFeeData})</label>
                                <Input
                                    type="range"
                                    min={5000}
                                    max={50000}
                                    step={5000}
                                    value={this.state.suggestCourseFeeData}
                                    onChange={(py) => {
                                        let x = py.target.value;
                                        this.setState({ suggestCourseFeeData: x }, () => {
                                            this.table.current.reload();
                                        });
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 10 }}>
                            <Col span={6}>
                                <label>Partnership</label>
                                <Select style={{ padding: '0.5rem 0rem' }}
                                    placeholder={'Partnership'}
                                    value={this.state.partnership}
                                    allowClear
                                    className={common.width100Pr}
                                    onChange={ei => {
                                        this.setState({ partnership: ei }, () => {
                                            this.table2.current.reload();
                                        });
                                    }}>
                                    {
                                        this.state.partnershipData.map((partnershipType, index) => {
                                            return (<Option key={index} value={partnershipType.id}>{partnershipType.display}</Option>)
                                        })
                                    }
                                </Select>
                            </Col>
                            <Col span={6} style={{ display: "flex", flexFlow: "row", marginTop: "20px" }}>
                                <label>University which have availability link</label>
                                <input
                                    style={{ marginLeft: "10px", cursor: "pointer" }}
                                    type="checkbox"
                                    name="preferredPartner"
                                    onChange={this.onSuggestedAvailabilityLink}
                                    checked={this.state.isSuggestedAvailabilityLink}
                                />
                            </Col>
                        </Row>
                        <Card bordered={true}>
                            <TableComp
                                ref={this.table2}
                                columns={columns}
                                apiRequest={this.loadSuggestedCourse}
                                extraProps={{ scroll: { x: 1100 } }}
                                pagination={{
                                    showSizeChanger: true,
                                    defaultPageSize: 20,
                                    pageSizeOptions: ["10", "20", "50", "100", "1000"],
                                }}
                            />
                        </Card>
                    </TabPane>)}
                <TabPane tab={"ALL COURSES"} key={!this.props.isComponent ? "0" : "1"}>
                    {
                        showAdvancedDrawer ?
                            <AdvancedFilters state={this.state} onClose={this.closeAdvancedFilter} />
                            : null
                    }
                    <Row>
                        <Col span={6}>
                            <label>SEARCH BY COUNTRY</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                allowClear
                                mode="tags"
                                className={common.width100Pr}
                                showSearch={true}
                                value={this.state.universityCountryId}
                                placeholder="Select Country"
                                optionFilterProp="display"
                                onChange={this.onCountryChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {countryArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val.id}>
                                            {val.display}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Col>
                        <Col span={6}>
                            <label>SEARCH BY UNIVERSITY</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                allowClear
                                showSearch={true}
                                className={common.width100Pr}
                                value={this.state.courseUniversityId}
                                placeholder="Select University"
                                optionFilterProp="universityInstitutionName"
                                onChange={this.onUniChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {uniArr && uniArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val._id}>
                                            {val.universityInstitutionName}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Col>
                        <Col span={12}  >
                            <label>SEARCH BY COURSE</label>
                            <Input style={{ padding: '0.5rem 0rem' }}
                                className={common.width100Pr}
                                allowClear={true}
                                onChange={(py) => {
                                    let x = py.target.value;
                                    this.setState({ courseNameData: x }, () => {
                                        if (x.length > 3 || x.length == 0) {
                                            this.table.current.reload();
                                        }
                                    });
                                }}
                            />
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col span={6}  >
                            <label>SEARCH BY COURSE</label>
                            <Input style={{ padding: '0.5rem 0rem' }}
                                className={common.width100Pr}
                                allowClear={true}
                                onChange={(py) => {
                                    let x = py.target.value;
                                    this.setState({ courseNameData: x }, () => {
                                        if (x.length > 3 || x.length == 0) {
                                            this.table.current.reload();
                                        }
                                    });
                                }}
                            />
                        </Col>
                        <Col span={6}>
                            <label>SEARCH BY COUNTRY</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                allowClear
                                mode="tags"
                                className={common.width100Pr}
                                showSearch={true}
                                value={this.state.universityCountryId}
                                placeholder="Select Country"
                                optionFilterProp="display"
                                onChange={this.onCountryChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {countryArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val.id}>
                                            {val.display}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Col>
                        <Col span={6}>
                            <label>SEARCH BY STATE</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                allowClear
                                mode="tags"
                                showSearch={true}
                                className={common.width100Pr}
                                value={this.state.universityStateId}
                                placeholder="Select State"
                                optionFilterProp="display"
                                onChange={this.onStateChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {stateArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val.id}>
                                            {val.display}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Col>
                        <Col span={6}>
                            <label>SEARCH BY CITY</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                mode="multiple"
                                allowClear
                                showSearch={true}
                                className={common.width100Pr}
                                value={this.state.universityCityId}
                                placeholder="Select City"
                                optionFilterProp="display"
                                onChange={this.onCityChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {cityArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val.id}>
                                            {val.display}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Col>
                    </Row> */}
                    {/* <Row style={{ marginTop: 10 }}>
                        <Col span={6}>
                            <label>SEARCH BY UNIVERSITY</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                allowClear
                                showSearch={true}
                                className={common.width100Pr}
                                value={this.state.courseUniversityId}
                                placeholder="Select University"
                                optionFilterProp="universityInstitutionName"
                                onChange={this.onUniChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {uniArr && uniArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val._id}>
                                            {val.universityInstitutionName}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Col>
                        <Col span={6}>
                            <label>SEARCH BY CAMPUS</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                allowClear
                                showSearch={true}
                                className={common.width100Pr}
                                value={this.state.courseCampusId}
                                placeholder="Select Campus"
                                optionFilterProp="campusName"
                                onChange={this.onCampChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {campusArr && campusArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val._id}>
                                            {val.campusName}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Col>
                        <Col span={6}>
                            <label>SEARCH BY FACULTY</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                allowClear
                                showSearch={true}
                                className={common.width100Pr}
                                mode={"tags"}
                                value={this.state.courseFacultyId}
                                placeholder="Select Faculty"
                                optionFilterProp="display"
                                onChange={this.onFacultyChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {allFaculties &&
                                    allFaculties.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val._id}>
                                                {val.display}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        </Col>
                        <Col span={6}>
                            <label>SEARCH BY STREAM</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                allowClear={true}
                                mode={"tags"}
                                value={this.state.stream}
                                showSearch={true}
                                placeholder="Select Stream"
                                className={common.width100Pr}
                                onChange={(streams) => {
                                    this.setState({ stream: streams }, () => {
                                        this.table.current.reload();
                                    });
                                }}
                            >
                                <Option value={"MEDICAL"}>MEDICAL</Option>
                                <Option value={"NON-MEDICAL"}>NON MEDICAL</Option>
                                <Option value={"COMMERCE"}>COMMERCE</Option>
                                <Option value={"ARTS"}>ARTS</Option>
                            </Select>
                        </Col>
                    </Row> */}
                    {/* <Row style={{ marginTop: 10 }}>
                        <Col span={6}>
                            <label>SEARCH BY LEVEL</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                allowClear
                                showSearch={true}
                                mode={"tags"}
                                className={common.width100Pr}
                                placeholder="Select Level"
                                optionFilterProp="display"
                                onChange={(v) => {
                                    this.setState({ courseLevelId: v }, () => {
                                        this.table.current.reload();
                                    });
                                }}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {this.state &&
                                    this.state.levelArr.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val.id}>
                                                {val.display}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        </Col>
                        <Col span={6}>
                            <label>SEARCH BY DURATION</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                allowClear={true}
                                className={common.width100Pr}
                                onChange={(py) => {
                                    let x = py;
                                    this.setState({ courseDuration: x }, () => {
                                        this.table.current.reload();
                                    });
                                }}>
                                <option value={''}>Choose Option</option>
                                <option value={1}>One year or less</option>
                                <option value={2}>Two years</option>
                                <option value={3}>Three years</option>
                                <option value={4}>Four years or more</option>
                            </Select>
                        </Col>
                        <Col span={12}>
                            <label>SEARCH BY FEE(5000 - {this.state.courseFeeData})</label>
                            <Input style={{ padding: '0.5rem 0rem' }}
                                type="range"
                                min={5000}
                                max={500000}
                                step={5000}
                                value={this.state.courseFeeData}
                                id="searchFeeDatalist"
                                onChange={(py) => {
                                    let x = py.target.value;
                                    this.setState({ courseFeeData: x }, () => {
                                        this.table.current.reload();
                                    });
                                }}
                            />
                            <datalist id="feeDatalist">
                                <option value="5000" label="5000"></option>
                                <option value="10000" label="10000"></option>
                                <option value="15000" label="15000"></option>
                                <option value="20000" label="20000"></option>
                                <option value="25000" label="25000"></option>
                                <option value="30000" label="30000"></option>
                                <option value="35000" label="35000"></option>
                                <option value="40000" label="40000"></option>
                                <option value="45000" label="45000"></option>
                                <option value="50000" label="50000"></option>
                            </datalist>
                        </Col>
                    </Row> */}

                    {/* <Row style={{ marginTop: 10 }}>

                        <Col span={6}>
                            <label>SEARCH BY INTAKE</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                className={common.width100Pr}
                                showSearch
                                allowClear
                                mode={"tags"}
                                placeholder="Intake"
                                onChange={this.onChangeIntake}
                            >
                                <Option value={'Jan'}>Jan</Option>
                                <Option value={'Feb'}>Feb</Option>
                                <Option value={'Mar'}>Mar</Option>
                                <Option value={'April'}>April</Option>
                                <Option value={'May'}>May</Option>
                                <Option value={'June'}>June</Option>
                                <Option value={'July'}>July</Option>
                                <Option value={'Aug'}>Aug</Option>
                                <Option value={'Sept'}>Sept</Option>
                                <Option value={'Oct'}>Oct</Option>
                                <Option value={'Nov'}>Nov</Option>
                                <Option value={'Dec'}>Dec</Option>

                            </Select>
                        </Col>
                        <Col span={6}>
                            <label>SEARCH BY EXAM TYPE</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                placeholder={'Choose Exam'}
                                value={this.state.examType}
                                allowClear
                                className={common.width100Pr}
                                onChange={ei => {
                                    this.setState({ examType: ei }, () => {
                                        this.table.current.reload();
                                    });
                                }}>
                                <Option value={'IELTS'}>IELTS</Option>
                                <Option value={'PTE'}>PTE</Option>
                                <Option value={'TOEFL'}>TOEFL</Option>
                                <Option value={'CAE'}>CAE</Option>
                            </Select>
                        </Col>
                        <Col span={6}>
                            <label>Partnership</label>
                            <Select style={{ padding: '0.5rem 0rem' }}
                                placeholder={'Partnership'}
                                value={this.state.partnership}
                                allowClear
                                className={common.width100Pr}
                                onChange={ei => {
                                    this.setState({ partnership: ei }, () => {
                                        this.table.current.reload();
                                    });
                                }}>
                                {
                                    this.state.partnershipData.map((partnershipType, index) => {
                                        return (<Option key={index} value={partnershipType.id}>{partnershipType.display}</Option>)
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={6} style={{ display: "flex", flexFlow: "row", marginTop: "20px" }}>
                            <label>IELTS 5.5 (Acceptable in one module)</label>
                            <input style={{ marginLeft: "10px", cursor: "pointer", padding: '0.5rem 0rem' }}

                                type="checkbox"
                                name="checkboxIeltsScoreAcceptable"
                                onChange={this.onIeltsChange}
                                checked={this.state.isIeltsScoreAcceptable}
                            />
                        </Col>
                    </Row> */}
                    {/* <Row style={{ marginTop: 10 }}>
                        <Col span={8} style={{ display: "flex", flexFlow: "row", marginTop: "20px", display: "inline-block" }}>
                            <label>3 Years Bachelor degree acceptance</label>
                            <input
                                style={{ marginLeft: "10px", cursor: "pointer" }}
                                type="checkbox"
                                name="checkboxBachelorDegreeAcceptable"
                                onChange={this.onDegreeChange}
                                checked={this.state.isBachelorDegreeAcceptable}
                            />
                        </Col>
                        <Col span={3} style={{ display: "flex", flexFlow: "row", marginTop: "20px" }}>
                            <label>MOI</label>
                            <input style={{ marginLeft: "10px", cursor: "pointer", padding: '0.5rem 0rem' }}
                                type="checkbox"
                                name="moi"
                                onChange={this.onMoiChange}
                                checked={this.state.isMoi}
                            />
                        </Col>
                        <Col span={5} style={{ display: "flex", flexFlow: "row", marginTop: "20px" }}>
                            <label>Preferred Partner</label>
                            <input style={{ marginLeft: "10px", cursor: "pointer", padding: '0.5rem 0rem' }}
                                type="checkbox"
                                name="preferredPartner"
                                onChange={this.onPreferredPartner}
                                checked={this.state.isPreferredPartner}
                            />
                        </Col>
                        <Col span={8} style={{ display: "flex", flexFlow: "row", marginTop: "20px" }}>
                            <label>University which have availability link</label>
                            <input style={{ marginLeft: "10px", cursor: "pointer", padding: '0.5rem 0rem' }}
                                type="checkbox"
                                name="preferredPartner"
                                onChange={this.onAvailabilityLink}
                                checked={this.state.isAvailabilityLink}
                            />
                        </Col>
                    </Row> */}
                    <Row>
                        <Col span={5}>
                            <Button type={"success"} onClick={this.resetForm}>
                                Reset
                            </Button>

                        </Col>
                    </Row>
                    <br />
                    <Card bordered={true}>
                        <TableComp
                            ref={this.table}
                            columns={columns}
                            apiRequest={this.apiRequest}
                            extraProps={{ scroll: { x: 1100 } }}
                            pagination={{
                                showSizeChanger: true,
                                defaultPageSize: 10,
                                pageSizeOptions: ["10", "20", "50", "100", "1000"],
                            }}
                        />
                    </Card>
                </TabPane>

            </Tabs>
        </Card>;

        return (
            isComponent ? (
                <PageHeaderWrapper title={'Course Finder'}>
                    {childUI}
                </PageHeaderWrapper>
            ) : (
                <Drawer
                    title={` Course List : ${this.state.total} `}
                    placement={"right"}
                    width={1250}
                    closable={true}
                    onClose={this.onClose}
                    visible={this.state.visible}
                >
                    <div> {childUI}
                    </div>
                </Drawer>)
        );
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CourseFinder);